import { Components, Theme } from '@mui/material';

export const getNavigationComponents = (
  theme: Theme,
): Pick<Components<Theme>, 'MuiTab' | 'MuiStepLabel'> => ({
  MuiTab: {
    styleOverrides: {
      root: {
        lineHeight: theme.lelyLineHeight.BASE,
      },
    },
  },
  MuiStepLabel: {
    styleOverrides: {
      label: {
        ...theme.typography.xs,
        fontFamily: theme.lelyFontFamily.NOTO,
        whiteSpace: 'pre-wrap',
      },
    },
  },
});
